import Svg, { Circle, NumberProp, Path } from "react-native-svg";

import { Carrier } from "../../delivery";

type Props = IsotypeProps & {
  carrier: Carrier | null;
};

export default function Isotype({ carrier, disabled, size = "1.5em" }: Props) {
  switch (carrier) {
    case "multientrega":
      return <Multientrega disabled={disabled} size={size} />;
    case "pedidosya":
      return <PedidosYa disabled={disabled} size={size} />;
    default:
      return null;
  }
}
const disabledColor = "rgba(131, 132, 133, 1)";

type IsotypeProps = {
  disabled?: boolean;
  size?: NumberProp;
};

function Multientrega({ disabled, size }: IsotypeProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <Circle cx="60" cy="60" r="50" fill="white" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55 52.3066V10.5H65V52.3066L83.5 34L89.5 40L60 69.5L30.5 40L36.5 34L55 52.3066Z"
        fill={disabled ? disabledColor : "#E03D2A"}
      />
      <Path
        d="M38.5 61L30.5 53.5V84.2961L38.5 92V61Z"
        fill={disabled ? disabledColor : "#E03D2A"}
      />
      <Path
        d="M60 84L65 79V95H55V79L60 84Z"
        fill={disabled ? disabledColor : "#E03D2A"}
      />
      <Path
        d="M89.5 53.5L81.5 61V92L89.5 84V53.5Z"
        fill={disabled ? disabledColor : "#E03D2A"}
      />
      <Path
        d="M60 6C89.8234 6 114 30.1766 114 60C114 89.8234 89.8234 114 60 114C30.1766 114 6 89.8234 6 60C6 30.1766 30.1766 6 60 6ZM60 11C32.938 11 11 32.938 11 60C11 87.062 32.938 109 60 109C87.062 109 109 87.062 109 60C109 32.938 87.062 11 60 11Z"
        fill={disabled ? disabledColor : "#273570"}
      />
    </Svg>
  );
}

function PedidosYa({ disabled, size }: IsotypeProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 150 150">
      <Path d="M0,.2H150v150H0Z" transform="translate(0 -0.2)" fill="none" />
      <Path
        d="M97.07,19.05H21.75a2,2,0,0,0-2,2V31.85c0,11.92,8.43,18.32,23.55,18.32h53.8a10.11,10.11,0,0,1,10.18,10.18A10.31,10.31,0,0,1,97.07,70.53H36.87A1.62,1.62,0,0,0,35.13,72L20.59,128.4a3.68,3.68,0,0,0,.29,1.74,1.59,1.59,0,0,0,1.45.88h19.2c7.27,0,10.47-5.82,11.34-9l5.53-20.36H96.78a41.45,41.45,0,0,0,41.3-41.29A40.84,40.84,0,0,0,97.07,19.05Z"
        transform="translate(0 -0.2)"
        fill={disabled ? disabledColor : "#f52f41"}
      />
    </Svg>
  );
}
